import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';

//  handles getting hover state to props,
//  also handles active state

// inline-block so it is as big as its contents
var HoverableDiv = glamorous.div({
  display: 'inline-block'
});

export function withHover(WrappedComponent) {
  var _class, _temp;

  return _temp = _class = function (_PureComponent) {
    _inherits(_class, _PureComponent);

    function _class(props) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

      _this.handleAnyMouseUp = function () {
        _this.setState({ active: false });
      };

      _this.componentWillUnmount = function () {
        document.removeEventListener('mouseup', _this.handleAnyMouseUp);
      };

      _this.handleMouseEnter = function () {
        _this.setState({ hovering: true });
      };

      _this.handleMouseLeave = function () {
        _this.setState({ hovering: false });
      };

      _this.handleMouseDown = function () {
        if (!_this.state.active) {
          _this.setState({ active: true });
          document.addEventListener('mouseup', _this.handleAnyMouseUp, { once: true });
        }
      };

      _this.render = function () {
        return React.createElement(
          HoverableDiv,
          {
            'data-qa': 'HoverableDiv',
            onMouseEnter: _this.handleMouseEnter,
            onMouseLeave: _this.handleMouseLeave,
            onMouseDown: _this.handleMouseDown,
            onClick: _this.clickHandler
          },
          React.createElement(WrappedComponent, _extends({ hovering: _this.state.hovering, active: _this.state.active }, _this.props))
        );
      };

      _this.state = {
        hovering: false,
        active: false
      };
      _this.clickHandler = _this.props.clickHandler ? _this.props.clickHandler : function () {};
      return _this;
    }

    return _class;
  }(PureComponent), _class.propTypes = {
    clickHandler: PropTypes.func
  }, _temp;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-common-ui/es/withHover.js
// module id = 662
// module chunks = 0